<template>
  <div class="left-menu">
    <div class="logo"><img alt="logo" class="logo-img" src="../../assets/images/logo-top.png"></div>
    <!-- <el-button type="primary" class="menu-btn" @click="goShopping">药品商城</el-button> -->
    <el-row class="tac">
      <el-col :span="12">
        <el-menu
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          @select="handleSelect"
          background-color="#203465"
          text-color="#ffffff"
          active-text-color="#FFFFFF"
          :default-active="$route.path"
          unique-opened
          router
        >
          <el-submenu 
            :index="index + ''" 
            v-for="(item, index) in $router.options.routes" 
            v-if="!item.menuHidden"
            :key="index">
            <template slot="title">
              <i class="iconfont icon-c" :class="[item.meta.icon]"></i>
              &nbsp;
              <span>{{item.label}}</span>
            </template>
            <el-menu-item 
            :index="item.path + '/' + it.path" 
            v-if="!it.menuHidden" 
            v-for="(it, idx) in item.children" 
            :key="idx"
            @click="meunChenge">
            <template>
              &nbsp;  {{it.label}}
            </template>
           </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
    </el-row>
    <div class="logo-bottom">
      <img alt="logo" class="ahs-img" src="../../assets/images/ahs_logo@2x.png">
    </div>
  </div>
</template>

<script>
export default {
  name: 'head-nav',
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect(e) {
      console.log(e);
      
      // this.$router.push(e);
    },
    goShopping() {
      const mywin = window.open();
      this.$api.global.loginShopping().then((res) => {
        console.log(res); 
        mywin.location.href = res.shop_url;
        // window.open(res.shop_url);
      })
    },
    meunChenge() {
      this.$emit('meunChenge');
    },
  },
  mounted() {
    // console.log(this.$route);
    for (const key in this.$router.options.routes) {
        console.log(this.$router.options.routes[key].label+"----"+this.$router.options.routes[key].menuHidden);
    }
  }
};
</script>
<style lang="scss">
.left-menu {
  width: 200px;
  height: 100vh;
  background: #1C2954;
  position: relative;
  z-index: 2001;
  overflow-y: scroll;
  .logo {
    height: 130px;
    text-align: center;
    .logo-img{
      width: 153px;
      height: 42px;
      margin-top: 37px;
    }
  }
  .menu-btn {
    margin-left: 50%;
    transform: translateX(-50%);
    margin-bottom: 40px;
    width: 120px;
  }
}
.left-menu::-webkit-scrollbar {
  display: none;
}
.el-menu {
  width: 200px;
  position: relative;
}
.el-submenu__title {
  span {
    font-size: 16px;
  }
}
.el-submenu__title i {
  color: #fff !important;
}
.el-submenu.is-opened {
  .is-active {
    background-color: #274B88 !important;
  }
  .el-menu-item {
    margin-top: 3px;
    height: 48px;
    line-height: 48px;
    font-size: 14px;
  }
  .el-submenu__title{
    // border-left: 4px solid #3F97FF;
    color: #FFFFFF !important;
    text-indent: -4px;
    background-color: #274B88 !important;
  }
  .icon-c{
    color: #FFFFFF !important;
  }
}
.tac {
  z-index: 2;
}
.icon-c {
  font-size: 16px;
  color: #fff !important;
}
.el-menu-item {
  font-size: 14px;
}
.ahs-img {
  width: 142px;
  height: 49px;
}
.logo-bottom {
  width: 200px;
  position: fixed;
  bottom: 20px;
  text-align: center;
  z-index: 1;
}

</style>
